/* The Urban Stem — HORIZONTAL RAIL builder.
   Reuses the same 66 pot renders as the wall and floor listings. What differs: two parallel
   3 ft rails run left to right, five pots hang beneath them (3 large, 2 small), and the arms
   at both ends double as the wall mounts.

   ONE THING STILL APPROXIMATE: the renders were shot with the arm attached to the pot's SIDE,
   for a vertical dowel. Here each pot hangs beneath the rails, so the arm is drawn in code
   above the pot and sized to cover the render's own arm stub. Once there's a straight-on photo
   of the horizontal unit the arm width/offset below can be measured properly. */
function usrInit(root){
  if (!root || root.dataset.usReady) return;
  root.dataset.usReady = '1';

  var ASSET_BASE = root.dataset.assetBase || '';

  var GEO = {
    'large-archie': {white:[621,160,411,748.4,2.372,2.37], black:[603,155,398,748.7,1.771,1.966], latte:[627,164,417,749.8,-0.042,0], terracotta:[605,166,409,750.1,1.985,2.209], green:[613,153,404,750,0,0.469], blue:[604,157,399,749.4,1.577,1.606]},
    'large-echo': {white:[620,108,359,749.5,0.137,0.359], black:[612,97,346,750.2,0.261,0], latte:[602,99,347,749.1,0.551,0.601], terracotta:[602,100,349,750.1,0.183,0.6], green:[613,111,356,748.9,0.903,1.213], blue:[597,96,344,750.4,-0.48,-0.364]},
    'large-lattice': {white:[576,106,366,749.4,0.719,0.573], black:[591,113,377,747.7,0.718,0.342], latte:[561,97,346,749.3,0.31,0.238], terracotta:[563,98,353,750.4,-0.344,-0.122], green:[576,104,361,750.1,0.424,0.581], blue:[586,113,376,749.2,0.825,0.344]},
    'large-linus': {white:[602,167,412,750.4,0.796,1.213], black:[623,157,408,750.1,0.243,0], latte:[584,141,382,750.9,-0.958,-0.862], terracotta:[602,158,406,750.5,0.109,0.238], green:[587,153,393,750.6,0.959,0.999], blue:[628,149,411,750.5,-0.146,0]},
    'large-poppy': {white:[607,159,418,749.4,1.673,1.957], black:[604,148,390,750.4,1.093,1.234], latte:[613,158,407,749.9,0.988,1.325], terracotta:[625,156,413,748.8,1.11,1.513], green:[578,147,389,749.5,0.394,0.245], blue:[606,150,397,749.2,1.28,1.337]},
    'large-smooth': {white:[608,159,417,750,0.608,0.926], black:[604,164,412,750.2,0.395,0.601], latte:[593,153,401,750.2,-0.482,-0.238], terracotta:[630,176,434,750.2,1.358,1.731], green:[598,150,407,749.8,1.467,1.391], blue:[597,151,402,750.6,0.121,0.359]},
    'large-spiral': {white:[565,100,343,749.1,1.362,1.597], black:[578,106,352,750.4,-0.725,-0.85], latte:[568,99,348,750.2,-0.092,0], terracotta:[584,104,358,750.7,-0.345,0], green:[554,91,332,750.5,0.022,0], blue:[571,99,341,750,-0.236,0]},
    'small-archie': {white:[455,75,327,749.9,1.177,1.306], black:[457,84,334,749.4,0.402,0.36], latte:[455,76,327,749.6,0.816,1.185], terracotta:[446,78,326,750.1,0.498,0.839], green:[451,85,336,749.3,1.433,1.779], blue:[454,87,329,750.7,0.79,0.862]},
    'small-linus': {white:[453,78,330,749.6,-0.164,-0.235], black:[448,81,325,750.4,-0.197,-0.241], latte:[450,76,325,750.5,0.675,0.601], terracotta:[452,86,335,750.1,1.032,1.439], green:[449,89,338,750.4,-0.1,0], blue:[446,82,325,749.4,0.143,0.37]},
    'small-poppy': {white:[462,93,344,750.3,0.449,0], black:[449,89,337,750.2,1.226,1.203], latte:[447,85,333,749.3,1.26,1.44], terracotta:[445,75,327,749.8,0.04,0.357], green:[443,87,338,749.8,0.52,0.717], blue:[462,81,330,749.2,2.534,2.762]},
    'small-smooth': {white:[463,80,340,750.1,1.713,2.29], black:[458,80,339,750.4,0.25,0.577], latte:[460,72,333,748.9,1.35,1.364], terracotta:[456,76,334,750,-0.181,0], green:[464,90,348,749.4,1.591,1.731], blue:[459,71,330,748.9,2.125,2.423]}
  };

  /* Measured off the white renders, by scanning rows below the collar and taking the pot's own
     run of pixels: [left, right, top, bottom] of the POT alone. The dowel never reaches past
     x=793 in any render, so cutting at the left figure removes the dowel and the arm together —
     that is what turns the arm to the back — while keeping every pixel of the pot itself. */
  var BODY = {
    'large-archie':[813,1186,58,565], 'large-echo':[813,1171,58,563], 'large-lattice':[807,1184,58,521],
    'large-linus':[812,1185,58,546], 'large-poppy':[813,1176,58,551], 'large-smooth':[828,1213,58,554],
    'large-spiral':[823,1177,58,512], 'small-archie':[815,1072,58,397], 'small-linus':[816,1072,58,395],
    'small-poppy':[817,1074,58,403], 'small-smooth':[837,1090,58,406]
  };

  /* ---------- stage geometry, 70 units per inch ---------- */
  var UPI = 70;
  var L = parseFloat(root.dataset.rail || '36'); if (!(L > 12 && L < 96)) L = 36;

  var RAIL_D = 70, RAIL_HALF = 35;          // 1 in. dowels
  var RAIL_GAP = 35;                        // 1/2 in. of daylight between the two rails
  var TOP_PAD = 108;

  var POT_INSET_TOP = 58, POT_INSET_BOT = 56;
  var TALLEST = 510;                          // deepest pot body across the renders

  var railLen = L * UPI;
  var SW = Math.round(railLen + 560);
  var SH = Math.round(SW / 4.5);                         // the drawn band's own 9/2 aspect; on
                                                         // mobile the stage is taller and rescale()
                                                         // centers the band in it vertically

  /* The rails run through the middle of each pot — half the pot above the wood, half below —
     so the rails' own centre line is the anchor everything hangs off. */
  var railMidY = Math.round(SH / 2);
  var railTopC = railMidY - (RAIL_D + RAIL_GAP) / 2;     // upper rail centre line
  var railBotC = railMidY + (RAIL_D + RAIL_GAP) / 2;     // lower rail centre line

  var RAIL_X0 = Math.round((SW - railLen) / 2), RAIL_X1 = RAIL_X0 + railLen;

  /* five positions, left to right: large, small, large, small, large — the two ends are the
     wall mounts, which on this model hold pots as well */
  var SLOTS = [
    {size:'large', label:'1'},
    {size:'small', label:'2'},
    {size:'large', label:'3'},
    {size:'small', label:'4'},
    {size:'large', label:'5'}
  ];
  /* Pots 1 and 5 sit right on the rail ends, covering the wall mounts underneath them. */
  var span = railLen / 4;
  for (var si = 0; si < 5; si++) SLOTS[si].x = Math.round(RAIL_X0 + span * si);

  var NAMES = {white:'White',black:'Black',latte:'Latte',terracotta:'Terracotta',green:'Green',blue:'Blue',
    archie:'Archie',echo:'Echo',lattice:'Lattice',linus:'Linus',poppy:'Poppy',smooth:'Smooth',spiral:'Spiral'};
  var WOOD_ACROSS = 'linear-gradient(to bottom,#6A5B49 0%,#937659 8%,#AA8865 14%,#AC8962 20%,'
    + '#B5936D 26%,#C09E77 34%,#C7A780 43%,#CBAC88 50%,#CDB08E 58%,#CDB091 66%,#CAB090 73%,'
    + '#C4AB8F 80%,#BDA58C 87%,#B19C86 93%,#A29589 100%)';
  var LARGE = ['archie','echo','lattice','linus','poppy','smooth','spiral'];
  var SMALL = ['archie','linus','poppy','smooth'];
  var COLORS = ['white','black','latte','terracotta','green','blue'];

  var build = [['archie','white'],['archie','white'],['archie','white'],['archie','white'],['archie','white']];
  /* optional data-build="shape:color|..." starting combination, used by the room scenes */
  if (root.dataset.build){
    var seed = root.dataset.build.split('|');
    if (seed.length === 5) build = seed.map(function(p){ var b = p.split(':'); return [b[0], b[1]]; });
  }
  var active = -1, view = -1, layer = [0,0,0,0,0], cache = {};

  var stage  = root.querySelector('[data-stage]');
  var base   = root.querySelector('[data-base]');
  var group  = root.querySelector('[data-group]');
  var photo  = root.querySelector('[data-photo]');
  var badge  = root.querySelector('[data-badge]');
  var thumbs = root.querySelectorAll('[data-view]');
  var pots = [[],[],[],[],[]];
  Array.prototype.forEach.call(root.querySelectorAll('[data-pot]'), function(el){ pots[+el.dataset.pot].push(el); });

  function key(i,shape,color){ return SLOTS[i].size + '-' + shape + '-' + color; }
  function src(i,shape,color){ return ASSET_BASE + 'urban-stem-' + key(i,shape,color) + '.png'; }
  function preload(u){ if(!u) return null; if(cache[u]) return cache[u]; var im=new Image(); im.src=u; cache[u]=im; return im; }
  function qs(sel){ return root.querySelector(sel); }
  function pxs(n){ return n.toFixed(2) + 'px'; }

  /* ---------- the rails, drawn once in stage units then scaled as one piece ---------- */
  function drawRails(){
    if (!base) return;
    base.style.width  = SW + 'px';
    base.style.height = SH + 'px';

    [['[data-rail="0"]', railTopC], ['[data-rail="1"]', railBotC]].forEach(function(pair){
      var el = qs(pair[0]); if (!el) return;
      el.style.left   = pxs(RAIL_X0);
      el.style.top    = pxs(pair[1] - RAIL_HALF);
      el.style.width  = pxs(railLen);
      el.style.height = pxs(RAIL_D);
      el.style.backgroundImage =
        'linear-gradient(to right,rgba(60,42,24,.16),rgba(60,42,24,0) 3%,rgba(60,42,24,0) 96%,rgba(60,42,24,.13)),'
        + 'repeating-linear-gradient(0deg,rgba(255,255,255,0) 0 2px,rgba(104,76,48,.055) 2px 3px,rgba(255,255,255,.035) 3px 6px),'
        + WOOD_ACROSS;
    });

    /* Nothing is drawn at the rail ends: on this model the mounts are part of the outer pots
       and sit behind them, so there is no separate hardware to show or to colour. */

    Array.prototype.forEach.call(root.querySelectorAll('[data-pot]'), function(el){
      el.style.width = (1500 / SW * 100).toFixed(4) + '%';
    });
  }

  function rescale(){
    if (!base || !stage) return;
    var w = stage.clientWidth;
    if (!w) return;
    var k = w / SW, bh = SH * k;
    base.style.transform = 'scale(' + k + ')';
    /* The stage may be taller than the drawn 9/2 band (mobile). The whole group — rails,
       pots and shadows together — is sized to the band and centered in the stage, and the
       hotspots follow via the two custom properties. */
    var dy = Math.max(0, (stage.clientHeight - bh) / 2);
    if (group){ group.style.top = dy + 'px'; group.style.height = bh + 'px'; group.style.bottom = 'auto'; }
    stage.style.setProperty('--usr-dy', dy + 'px');
    stage.style.setProperty('--usr-bh', bh + 'px');
  }

  /* ---------- pots ---------- */
  function body(i,shape){ return BODY[SLOTS[i].size + '-' + shape]; }
  function reach(i,shape){ var b = body(i,shape); return (b[1] - b[0]); }

  function place(el,i,shape,color){
    var g = GEO[SLOTS[i].size+'-'+shape][color];
    var H=g[0];
    var b = body(i,shape), potL = b[0];
    var pTop = POT_INSET_TOP, pBot = H - POT_INSET_BOT;   // per-colour, from this render's own H
    function edge(){ return (potL/1500*100).toFixed(3) }
    function pc(y){ return (y/H*100).toFixed(3) }

    var bodyMid = (b[0] + b[1]) / 2;
    el.style.left = ((SLOTS[i].x - bodyMid)/SW*100).toFixed(4)+'%';
    // centre the pot on the rails, so half of it stands above the wood and half below
    el.style.top  = ((railMidY - (pTop + pBot)/2)/SH*100).toFixed(4)+'%';
    el.style.transform = 'none';
    el.style.clipPath = el.style.webkitClipPath =
      'polygon('+edge()+'% '+pc(pTop)+'%, 100% '+pc(pTop)+'%, 100% '+pc(pBot)+'%, '
      +edge()+'% '+pc(pBot)+'%)';
  }

  function hotspot(i){
    var el = qs('[data-hot="'+i+'"]'); if(!el) return;
    var w = reach(i, build[i][0]) + 30;
    el.style.left   = ((SLOTS[i].x - w/2)/SW*100).toFixed(3)+'%';
    el.style.width  = (w/SW*100).toFixed(3)+'%';
    el.style.top    = 'calc(var(--usr-dy,0px) + ' + ((railMidY - TALLEST/2 - 20)/SH).toFixed(5) + ' * var(--usr-bh,100%))';
    el.style.height = 'calc(' + ((TALLEST + 40)/SH).toFixed(5) + ' * var(--usr-bh,100%))';
  }

  function setSlot(i,shape,color,instant){
    var u = src(i,shape,color); if(!u) return;
    var cur = layer[i];
    var from = pots[i][cur], to = pots[i][cur?0:1];
    var im = preload(u);
    var done = false;
    function reveal(){ if(done) return; done=true;
      to.style.opacity='1'; from.style.opacity='0'; layer[i] = cur?0:1; }
    if (instant){
      place(from,i,shape,color); from.src=u; from.style.opacity='1'; to.style.opacity='0';
    } else {
      place(to,i,shape,color); to.src=u;
      if (im.complete && im.naturalWidth) reveal();
      else { im.onload=reveal; im.onerror=reveal; setTimeout(reveal,400); }
    }
    hotspot(i);
  }

  function warm(){
    for (var i=0;i<5;i++){
      var shapes = SLOTS[i].size==='large'?LARGE:SMALL;
      for (var a=0;a<shapes.length;a++) preload(src(i,shapes[a],build[i][1]));
      for (var b=0;b<COLORS.length;b++) preload(src(i,build[i][0],COLORS[b]));
    }
  }

  var pending = false;
  function chipArt(){
    pending = false;
    Array.prototype.forEach.call(root.querySelectorAll('.us-chip-img'), function(img){
      var btn = img.parentNode, i = +btn.dataset.slot, shape = btn.dataset.shape;
      var g = GEO[SLOTS[i].size + '-' + shape]; if (!g) return;
      g = g.white;
      var H = g[0], b = BODY[SLOTS[i].size + '-' + shape];
      var x0 = b[0] - 12, x1 = b[1] + 12, y0 = POT_INSET_TOP - 8, y1 = (H - POT_INSET_BOT) + 8;
      var tw = btn.clientWidth, th = btn.clientHeight, pad = 5;
      if (!(tw > 20 && th > 20)) { pending = true; return; }
      var s = Math.min((tw - pad * 2) / (x1 - x0), (th - pad * 2) / (y1 - y0));
      if (!(s > 0)) { pending = true; return; }
      img.style.width  = (1500 * s).toFixed(2) + 'px';
      img.style.height = (H * s).toFixed(2) + 'px';
      img.style.left   = ((tw - (x1 - x0) * s) / 2 - x0 * s).toFixed(2) + 'px';
      img.style.top    = ((th - (y1 - y0) * s) / 2 - y0 * s).toFixed(2) + 'px';
    });
    if (pending) requestAnimationFrame(chipArt);
  }
  function watchChips(){
    var first = root.querySelector('.us-chip');
    if (!first || !window.ResizeObserver) return;
    new ResizeObserver(function(){ chipArt(); }).observe(first);
  }

  function paint(){
    for (var i=0;i<5;i++){
      var card = qs('[data-card="'+i+'"]');
      if (!card) continue;
      var shape = build[i][0], color = build[i][1];
      Array.prototype.forEach.call(card.querySelectorAll('button[data-shape]'), function(b){
        b.classList.toggle('is-on', b.dataset.shape===shape);
      });
      Array.prototype.forEach.call(card.querySelectorAll('[data-color]'), function(b){
        b.classList.toggle('is-on', b.dataset.color===color);
      });
      var sum = card.querySelector('[data-sum]');
      if (sum) sum.textContent = NAMES[shape]+' · '+NAMES[color];
      card.classList.toggle('is-active', active===i);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-preset]'), function(b){
      var ps = b.dataset.preset.split('|');
      var match = ps.length===5 && ps.every(function(p,i){
        var bits = p.split(':');
        return bits[0]===build[i][0] && bits[1]===build[i][1];
      });
      b.classList.toggle('is-on', match);
    });

    for (var j=0;j<5;j++){
      var inp = qs('[data-prop="'+j+'"]');
      if (inp) inp.value = NAMES[build[j][0]]+' · '+NAMES[build[j][1]]+' ('+SLOTS[j].size+')';
    }
    var codeInp = qs('[data-prop="code"]');
    if (codeInp) codeInp.value = build.map(function(p,i){ return SLOTS[i].size[0]+':'+p[0]+':'+p[1]; }).join('|');
  }

  function commit(instant){
    for (var i=0;i<5;i++) setSlot(i,build[i][0],build[i][1],instant);
    chipArt(); paint(); warm();
  }

  function setView(n){
    view = n;
    if (n<0){ photo.style.opacity='0'; badge.style.opacity='1'; }
    else {
      var t = qs('[data-view="'+n+'"]');
      if (t && t.dataset.src) photo.src = t.dataset.src;
      photo.style.opacity='1'; badge.style.opacity='0';
    }
    Array.prototype.forEach.call(thumbs, function(b){ b.classList.toggle('is-on', +b.dataset.view===n); });
  }

  root.addEventListener('click', function(e){
    var t;
    if ((t = e.target.closest('button[data-shape]'))){
      var i = +t.dataset.slot; active = i;
      build[i] = [t.dataset.shape, build[i][1]];
      setSlot(i, build[i][0], build[i][1], false); setView(-1); paint(); warm(); return;
    }
    if ((t = e.target.closest('[data-color]'))){
      var k = +t.dataset.slot; active = k;
      build[k] = [build[k][0], t.dataset.color];
      setSlot(k, build[k][0], build[k][1], false); setView(-1); paint(); warm(); return;
    }
    if ((t = e.target.closest('[data-all]'))){
      var c = build[+t.dataset.all][1];
      build = build.map(function(p){ return [p[0], c]; });
      setView(-1); commit(false); return;
    }
    if ((t = e.target.closest('[data-preset]'))){
      build = t.dataset.preset.split('|').map(function(p){ var b=p.split(':'); return [b[0],b[1]]; });
      setView(-1); commit(false); return;
    }
    if (e.target.closest('[data-random]')){
      build = SLOTS.map(function(s){
        var shapes = s.size==='large'?LARGE:SMALL;
        return [shapes[Math.floor(Math.random()*shapes.length)], COLORS[Math.floor(Math.random()*COLORS.length)]];
      });
      setView(-1); commit(false); return;
    }
    if ((t = e.target.closest('[data-hot]'))){
      var h = +t.dataset.hot; active = (active===h ? -1 : h); setView(-1); paint(); return;
    }
    if ((t = e.target.closest('[data-view]'))){ setView(+t.dataset.view); return; }
  });

  if (stage) stage.addEventListener('pointerenter', function(){ if (view<0) warm(); });

  drawRails();
  rescale();
  if (window.ResizeObserver && stage){ new ResizeObserver(rescale).observe(stage); }
  else window.addEventListener('resize', rescale);
  watchChips();
  commit(true);
  setView(-1);
}

function usrBoot(scope){
  var list = (scope || document).querySelectorAll('.usr[data-asset-base]');
  for (var i = 0; i < list.length; i++) usrInit(list[i]);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ usrBoot(); });
else usrBoot();
document.addEventListener('shopify:section:load', function(e){ usrBoot(e.target); });
